import { useUnit } from "effector-react"
import { t } from "i18next"
import { $userService } from "@callcenter/effector-services"
import type { UserPermission } from "@callcenter/services"

export const useAdminMenuItems = () => {
  const permissions = useUnit($userService.$permissions)
  const actualUserPermissions = useUnit($userService.$actualUserPermissions)

  const hasPermission = (permission: UserPermission) =>
    permissions.has(permission) || actualUserPermissions.has(permission)

  return [
    {
      label: t("mainMenuBar_adminMenu_callcentersOptionLabel_callcentersLabel"),
      path: "/admin/callcenters",
      isVisible: hasPermission("view_admin_all_callcenters") || hasPermission("view_admin_own_callcenters")
    },
    {
      label: t("mainMenuBar_adminMenu_usersOptionLabel_usersLabel"),
      path: "/admin/users",
      isVisible: hasPermission("view_admin_all_users") || hasPermission("view_admin_own_users")
    },
    {
      label: t("mainMenuBar_adminMenu_mediaGatewaysOptionLabel_mediaGatewaysLabel"),
      path: "/admin/media_servers",
      isVisible: hasPermission("view_media_gateways")
    },
    {
      label: t("mainMenuBar_adminMenu_uploadedCsvOptionLabel_uploadedCsvLabel"),
      path: "/admin/uploaded_csvs",
      isVisible: hasPermission("view_uploaded_csv")
    },
    {
      label: t("mainMenuBar_adminMenu_usageOptionLabel_usageLabel"),
      path: "/admin/usage_reports",
      isVisible: hasPermission("view_usage_reports")
    },
    {
      label: t("mainMenuBar_adminMenu_auditOptionLabel_auditLabel"),
      path: "/admin/audits",
      isVisible: hasPermission("view_admin_all_callcenters")
    },
    {
      label: t("mainMenuBar_adminMenu_dialerStatsOptionLabel_dialerStatsLabel"),
      path: "/admin/dialer_stats",
      isVisible: hasPermission("view_dialer_stats")
    },
    {
      label: t("mainMenuBar_adminMenu_creditCardsOptionLabel_creditCardsLabel"),
      path: "/admin/credit_cards",
      isVisible: hasPermission("view_credit_cards")
    },
    {
      label: t("mainMenuBar_adminMenu_creditCardsLogOptionLabel_creditCardsLogLabel"),
      path: "/admin/credit_cards_log",
      isVisible: hasPermission("view_credit_cards_logs")
    },
    {
      label: t("mainMenuBar_adminMenu_numberRewritingOptionLabel_numberRewritingLabel"),
      path: "/admin/number_rewriting",
      isVisible: hasPermission("view_number_rewriting")
    },
    {
      label: t("mainMenuBar_adminMenu_serviceNotificationsOptionLabel_serviceNotificationsLabel"),
      path: "/admin/service_notifications",
      isVisible: hasPermission("view_service_notifications")
    }
    // Only in development mode
    // {
    //   label: t("mainMenuBar_adminMenu_mockedMailerOptionLabel_mockedMailerLabel"),
    //   path: "/admin/mocked_mailer",
    //   isVisible: hasPermission("access_super_admin_settings")
    // }
  ].filter((item) => item.isVisible)
}
